import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { LinkToMonitorResultsDoc } from '../links'
import { Path } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'

const description = 'Monitor Results shows an overview of results from your test runs. You also can view full details of tests and download logs from this area.'

const MonitorResultsIntro = () =>
  <div className='grid h-full justify-center'>
    <div className='grid w-[36em]'>
      <EmptyStatesPreview
        description={description}
        icon={<Path />}
        renderLink={<LinkToMonitorResultsDoc />}
        title='Monitor Results'
      />
    </div>
  </div>

export default MonitorResultsIntro
